import styled, { css } from "styled-components"

import { typography, textColorVariables, colors } from "@izettle/otto"

import { marginTopBottomMixin, Margins } from "../../mixins"

type TextColorVariables = keyof typeof textColorVariables
type TextColors = keyof typeof colors.text
type SetTextVariableColor = (
  textColorVariable: TextColorVariables,
  textColor: TextColors,
) => string

const setTextVariableColor: SetTextVariableColor = (textColorVariable, textColor) =>
  `${textColorVariables[textColorVariable]}: ${colors.text[textColor]};`

export const whiteTextMixin = css`
  -webkit-font-smoothing: antialiased;
  ${setTextVariableColor("primary", "inverted")}
  ${setTextVariableColor("secondary", "inverted")}
`

export const textColorMixin = (color: TextColors) => css`
  ${setTextVariableColor("primary", color)}
  ${setTextVariableColor("secondary", color)}
`

// prettier-ignore
export const Text = {
  Huge: styled.p<Margins>`
    ${typography.huge}
    ${marginTopBottomMixin({ top: "xLarge", bottom: "xxSmall"})}
  `,
  Title1: styled.h1<Margins>`
    ${typography.title1}
    ${marginTopBottomMixin({ top: "large", bottom: "none" })}
    `,
  Title2: styled.h2<Margins>`
    ${typography.title2}
    ${marginTopBottomMixin({ top: "large", bottom: "none" })}
  `,
  Title3: styled.h3<Margins>`
    ${typography.largeBold}
    ${marginTopBottomMixin({ top: "large", bottom: "none" })}
  `,
  Large: styled.p<Margins>`
    ${typography.large}
    ${marginTopBottomMixin({ top: "xxSmall", bottom: "small" })}
  `,
  LargeBold: styled.p<Margins>`
    ${typography.largeBold}
    ${marginTopBottomMixin({ top: "xxSmall", bottom: "small" })}
  `,
  Regular: styled.p<Margins>`
    ${typography.regular}
    ${marginTopBottomMixin({ top: "tiny", bottom: "small" })}
  `,
  RegularBold: styled.p<Margins>`
    ${typography.regularBold}
    ${marginTopBottomMixin({ top: "tiny", bottom: "small" })}
  `,
  RegularSecondary: styled.p<Margins>`
    ${typography.regularSecondary}
    ${marginTopBottomMixin({ top: "tiny", bottom: "small" })}
  `,
  RegularLongText: styled.p<Margins>`
    ${typography.regularLongText}
    ${marginTopBottomMixin({ top: "tiny", bottom: "small" })}
  `,
  Small: styled.p<Margins>`
    ${typography.small}
    ${marginTopBottomMixin({ top: "xxSmall", bottom: "small"})}
  `,
  SmallBold: styled.p<Margins>`
    ${typography.smallBold}
    ${marginTopBottomMixin({ top: "xxSmall", bottom: "small"})}
  `,
  SmallSecondary: styled.p<Margins>`
    ${typography.smallSecondary}
    ${marginTopBottomMixin({ top: "xxSmall", bottom: "small"})}
  `,
  SmallCaps: styled.p<Margins>`
    ${typography.smallCaps}
    ${marginTopBottomMixin({ top: "xSmall", bottom: "xSmall" })}
  `,
  SmallCapsSecondary: styled.p<Margins>`
    ${typography.smallCapsSecondary}
    ${marginTopBottomMixin({ top: "xSmall", bottom: "xSmall" })}
  `,
  Mini: styled.p<Margins>`
    ${typography.mini}
    ${marginTopBottomMixin({ top: "xSmall", bottom: "small"})}
  `,
}
